import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("admin@startup.io");
  const [password, setPassword] = useState("admin123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      const to = location.state?.from?.pathname || "/";
      navigate(to, { replace: true });
    } else setError(res.error);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5 bg-background">
      {/* Left brand panel */}
      <div className="hidden lg:flex lg:col-span-2 flex-col justify-between p-10 border-r border-border bg-card">
        <img
          src="/brand/elevante-logo.png"
          alt="elevante.ai"
          className="h-9 w-auto self-start select-none"
          data-testid="brand-logo-login"
          draggable={false}
        />

        <div className="max-w-md">
          <div className="eyebrow mb-3">Built for early-stage teams</div>
          <h1 className="text-4xl leading-[1.05] tracking-tighter font-medium">
            The pipeline<br />you&rsquo;ll actually<br /><span className="text-primary">keep updated.</span>
          </h1>
          <p className="mt-6 text-sm text-muted-foreground leading-relaxed max-w-sm">
            One clean workspace for contacts, companies, deals and the tasks that move them forward. No bloat, no seat tax, no purple gradients.
          </p>
        </div>

        <div />
      </div>

      {/* Right form */}
      <div className="lg:col-span-3 flex items-center justify-center px-6 py-14">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="eyebrow mb-2">Welcome back</div>
            <h2 className="text-2xl tracking-tight font-medium">Sign in to your workspace</h2>
          </div>

          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <div className="text-right">
                <Link
                  to="/forgot-password"
                  data-testid="forgot-password-link"
                  className="text-xs text-muted-foreground hover:text-primary transition-colors"
                >
                  Forgot password?
                </Link>
              </div>
            </div>
          </div>

          {error && (
            <div
              data-testid="login-error"
              className="text-sm text-destructive border border-destructive/30 bg-destructive/5 rounded-md px-3 py-2"
            >
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full h-10 bg-primary hover:bg-primary/90 text-primary-foreground active:scale-[.98] transition-transform duration-100"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
